import './styles.scss'

interface ProgressBarProps {
  percent: number
}

const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  const { percent } = props

  return (
    <div className='b-progress'>
      <div className='b-progress__bar' style={{ width: `${percent}%` }} />
    </div>
  )
}

export default ProgressBar
